<template>
  <div id="base-items">
    <div class="base-items-inner d-flex">

      <button v-if="category.children.length === 0" class="btn btn-outline-secondary d-flex start-message" @click.stop="addBaseNavItem">Click here to create a Navigation Item</button>

      <draggable
        v-if="category.children.length !== 0"
        tag="div"
        class="base-items-inner d-flex"
        @change="setBaseItemsOrder()"
        v-model="category.children"
        v-bind="dragOptionsBaseItems"
        :group="{pull: false}"
        :id="category.id"
      >

        <div
          v-for="baseItem in category.children"
          :key="baseItem.id"
          class="nav-item"
          :class="{ 'selected' : baseItem.id === selectedItemId }"
          :id="baseItem.id"
          :data-label="baseItem.label"
          :data-order="baseItem.order"
          :data-screenId="baseItem.screenId"
          :data-videoWallTrigger="baseItem.videoWallTrigger"
          @click.stop="navItemClick($event, baseItem)"
        >

          <div class="nav-item__label" v-html="baseItem.label[lang]"></div>

          <draggable 
            v-model="baseItem.children"
            v-bind="dragOptionsChildItems"
            class="nav-item-child"
            :group="{ pull: true, put: true }"
            @change="setChildItemsOrder(baseItem)"
          >

            <div
              v-for="childItem in baseItem.children"
              class="child-nav-item" 
              :class="{ 'selected' : childItem.id === selectedItemId }"
              :key="childItem.id"
              :id="childItem.id"
              @click.stop="navItemClick($event, childItem)"
            >
              <fa v-if="childItem.icon[0] !== '' && childItem.icon[1] !== ''" class="no-events mx-2" :icon="[childItem.icon[0], childItem.icon[1]]" />
              <span class="no-events" v-html="childItem.label[lang]"></span>
            </div>
          </draggable>

          <div slot="footer" class="nav-item__add" @click.stop="addChildNavItem($event)">+</div>

        </div> <!-- base items -->
      </draggable>

      <div v-if="category.children.length !== 0" class="nav-item__base-add" @click.stop="addBaseNavItem($event)">+</div>

    </div>
  </div> 
</template>
<script>
import draggable from 'vuedraggable';
import _ from 'lodash';

export default {

  name: 'nav-items-draggable',

  components: {
    draggable
  },

  props: {
    navigation: Array,
    category: Object,
    selectedItemId: String,
    selectedTabId: String,
    dir: String,
    lang: String
  },

  computed: {
    dragOptionsBaseItems() {
      return {
        animation: 120,
        group: "baseitems",
        disabled: false,
        ghostClass: "ghostly"
      };
    },

    dragOptionsChildItems() {
      return {
        animation: 120,
        group: "childitems",
        disabled: false,
        ghostClass: "ghostly"
      };
    },

    highestNavId () {
      let ids = [];

      this.navigation.forEach(screen => {
        ids.push(screen.id);

        screen.children.forEach(baseItem => {
          ids.push(baseItem.id);

          baseItem.children.forEach(childItem => {
            ids.push(childItem.id);
          });
        });
      });

      let highestId = Math.max(...ids) + 1;

      if (highestId == '-Infinity') {
        highestId = 1
      }

      return highestId.toString();
    },

    selectedCategory() {
      let category = _.find(this.navigation, category => {
        return category.id == this.selectedTabId;
      });

      return category
    }
  },

  methods: {
    addBaseNavItem(event) {
      this.$emit('addBaseNavItem', event)
    },

    addChildNavItem(event) {
      this.$emit('addChildNavItem', event)
    },

    navItemClick(event, item) {
      this.$emit('navItemClick', event, item)
    },

    setBaseItemsOrder() {
      this.$emit('setBaseItemsOrder')
    },

    setChildItemsOrder(parentItem) {
      this.$emit('setChildItemsOrder', parentItem)
    },
  }
}
</script>
<style lang="scss">

#base-items {
  flex-direction: row;
  width: 100%;

  .base-items-inner {
    width: 100%;
  }

  .nav-item {
    background: #b1bfd0;;
    border-radius: 6px;
    cursor: move;
    flex-grow: 1;
    margin: 0 2px;
    padding: 8px 8px 38px;
    text-align: center;
    transition: background 200ms ease-in-out;

    &:hover {
      background: darken(#b1bfd0, 10%);
    }

    &.selected {
      background: darken(#b1bfd0, 20%);

      .nav-item__label {
        color: #fff;
      }

      &:hover {
        background: darken(#b1bfd0, 23%);
      }
    }

    &__label {
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 1px;
      margin: 6px 0 12px;
      pointer-events: none;
    }

    &__base-add {
      align-items: center;
      border: 2px dashed darken(#a0a0a0, 23%);
      border-radius: 6px;
      color: darken(#a0a0a0, 23%);
      cursor: pointer;
      display: flex;
      margin: 0 6px;
      min-height: 126px;
      padding: 2px 8px;
      text-align: center;
      transition: background 200ms ease-in-out;

      &:hover {
        border: 2px dashed #000;
        color: #000;
      }
    }

    &__add {
      border: 2px dashed #333;
      border-radius: 6px;
      cursor: pointer;
      line-height: 1;
      margin: 0 6px;
      padding: 10px 8px;
      text-align: center;
      transition: background 200ms ease-in-out;

      &:hover {
        border: 2px dashed #fff;
        color: #fff;
      }
    }
  }

  .nav-item-child {
    pointer-events: none;
  }

  .child-nav-item {
    background: #f0f0f0;
    border-radius: 6px;
    color: #222;
    line-height: 1;
    margin: 4px 6px;
    padding: 12px 8px;
    pointer-events: auto;
    text-align: center;
    transition: background 200ms ease-in-out;

    &:hover {
      background: darken(#f0f0f0, 10%);
    }

    &.selected {
      background: darken(#f0f0f0, 15%);

      &:hover {
        background: darken(#f0f0f0, 20%);
      }
    }
  }
}

.no-events {
  pointer-events: none;
}

.ghostly {
  opacity: .15;
}

.preview {

  i,
  svg {
    font-size: 30px;
    margin: 15px 0 0 15px;
  }
}

.start-message {
  margin: 44px auto;
}
</style>